import React, { useContext } from "react";
import AppContext from "app/context/AppContext";

function withAppContext(Component) {
    return function WrappedComponent(props) {
      const appContext = useContext(AppContext);
      return <Component {...props} appContext={appContext} />;      
    }
  }

export default withAppContext;